import React, { useEffect } from "react";
import { Button, Card, Popconfirm, Tree } from "antd";
import { useModel } from "../../../models";
import { OptType } from "./dictModel";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

function containsChildByKey(node, key) {
    if (node.hasOwnProperty("children")) {
        for (let childNode of node.children) {
            if (childNode) {
                if (childNode.key === key) {
                    return node;
                }
                const ret = containsChildByKey(childNode, key);
                if (ret != null) {
                    return ret;
                }
            }
        }
    }
}

function getPNodeByKey(key, initTreeData) {
    for (let node of initTreeData) {
        const pNode = containsChildByKey(node, key)
        if (pNode != null) {
            return pNode;
        }
    }
}

const DataDictTree = () => {
    const [{ selectNode, dictTree, selectPNode }, { setOptType, setSelectNode, setSelectPNode, loadDictTree }] = useModel("dict");
    useEffect(() => {
        loadDictTree();
    }, []);

    const selectedKeys = [selectNode ? selectNode.key : ""];
    const onSelect = (selectedKeys, info) => {
        //获取父节点
        const selectedNode = info.selectedNodes[0]
        const pNode = getPNodeByKey(selectedKeys[0], dictTree)

        selectedNode ? setOptType(OptType.DETAIL) : setOptType(OptType.ADD_ROOT);
        setSelectNode(selectedNode)
        setSelectPNode(pNode)
    };
    const onCheck = (checkedKeys, info) => {
        // console.log('onCheck', checkedKeys, info);
    };

    return (
        <Tree
            // defaultExpandAll
            // defaultExpandedKeys={['0-0-0']}
            selectedKeys={selectedKeys}
            onSelect={onSelect}
            onCheck={onCheck}
            treeData={dictTree}
        // style={{minHeight:"300px",overflowY:"auto"}}
        />
    );
};

export default function () {

    const [{ selectNode, selectPNode }, { setOptType, deleteDict }] = useModel("dict");

    const onAddRoot = () => {
        setOptType(OptType.ADD_ROOT);
    }
    const onAddSameLevel = () => {
        setOptType(OptType.ADD_SAME_LEVEL);
    }
    const onAddChildLevel = () => {
        setOptType(OptType.ADD_CHILD_LEVEL);
    }
    const onDeleteConfirm = () => {
        if (selectNode && selectNode.id) {
            let { id, pcode } = selectNode
            // let id = JSON.stringify(selectNode.id)
            deleteDict({ id, pcode });
        }
    }

    return (
        <Card
            title={
                <>
                    {
                        selectNode ? <>

                            <YhAuth resCode={ResourceAuthEnum.DATA_DIC_SUB}> <Button type="primary" onClick={onAddChildLevel}>增加下级</Button></YhAuth>
                            <YhAuth resCode={ResourceAuthEnum.DATA_DIC_BRO}> <Button className="margin-left-8" onClick={onAddSameLevel}>增加同级</Button></YhAuth>
                            <Popconfirm
                                placement="bottomLeft"
                                title={`确定删除节点[${selectNode.title}]?`}
                                onConfirm={onDeleteConfirm}
                                onCancel={() => console.log("cancel")}
                                okText="是"
                                cancelText="否"
                            >
                                <Button disabled={true} className="margin-left-8">删除</Button>
                            </Popconfirm>

                        </> : <YhAuth resCode={ResourceAuthEnum.DATA_DIC_FATHER}><Button type="primary" onClick={onAddRoot}>增加根级</Button></YhAuth>
                    }
                </>
            }
            bordered={true}
            className="margin-top-8"
            style={{ width: "360px", height: "100%", overflowY: "auto" }}
        >
            <DataDictTree />
        </Card>
    )

};